import { InvalidAddressDetailsError } from '../errors';

export const isInvalidAddressDetailsError = (error: unknown): error is InvalidAddressDetailsError => {
    return error instanceof InvalidAddressDetailsError;
};
